export interface PollingModalProps {
  title?: string;
  paragraphs?: string[];
  confirmText?: string;
  resourceUrl?: string | null;
  details?: Record<string, unknown> | null;
}

export interface ModalPayload {
  modal: 'editUser' | 'inviteExternal' | 'createSix' | 'systemConfirm' | 'profile' | 'fileUpload' | 'fileDetail' | 'manageAccess' | 'createFolder';
  modalProps?: PollingModalProps
}

export interface UiState {
  modal: ModalPayload['modal'] | null;
  modalProps?: ModalPayload['modalProps'];
  showLoader: boolean;
  errorMessage: string | null;
  pollingModal: {
    type: 'success' | 'error' | null;
    title?: string;
    message?: string;
    resourceUrl?: string | null;
    details?: Record<string, unknown> | null;
  };
}

export const initialUiState: UiState = {
  modal: null,
  modalProps: undefined,
  showLoader: false,
  errorMessage: null,
  pollingModal: {
    type: null,
  },
};

